export default {
  driver_performance_driver_title: "Driver Performance - Driver",
  driver_performance_driver_searchDriver: "Search by Driver",
  driver_performance_driver_id: "ID",
  driver_performance_driver_driver: "Driver",
  driver_performance_driver_avgEvents: "Average Risk Event",
  driver_performance_driver_RiskScore: "Risk Score",
  driver_performance_driver_stopVisited: "Stops Visited",
  driver_performance_driver_riskEvents: "Risk Events",
  driver_performance_driver_Events: "Events",
  driver_performance_driver_totalDistance: "Total Distance",
  driver_performance_driver_Tags: "Tags",
  driver_performance_driver_status_unassigned: "Unassigned",
  driver_performance_driver_lastCoaching: "Last Coaching",

  driver_performance_driver_sendToCoaching: "Send to Coaching",
  driver_performance_driver_shareDriver: "Share Driver",
};
